module.exports = __webpack_public_path__ + "img/fish-empty.aac1b8c9.png";